"use strict";
//Corey Wunderlich 2022
//https://www.wundervisionenvisionthefuture.com/
Object.defineProperty(exports, "__esModule", { value: true });
exports.Point3D = void 0;
class Point3D {
    constructor(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
    }
}
exports.Point3D = Point3D;
